import React, { useState, useEffect } from 'react';
import { styled } from '@mui/system';
import Dialog from '@mui/material/Dialog';

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Config } from '../../config/config';
import TextField from '@mui/material/TextField';
import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';
import { ProgressBar } from 'react-bootstrap';
import Cookie from 'js-cookie';
import axios from 'axios';
import { SpaceBarRounded } from '@mui/icons-material';
import { ThemeProvider, createTheme } from '@mui/material/styles'; 


const theme = createTheme();

const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontSize: "16px",
  maxWidth: "864px",
  background: "#3c8dbc",
  color: "#fff",
}));
const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#eaf7fdcc",
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});



const UploadProjectInvoice = (props) => {
  const [open, setOpen] = React.useState(props.invoiceEditing);
  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState('sm');

  const [invoiceNum, setInvoiceNum] = useState('');
  const [errors, setErrors] = useState('');
  const [invoiceArray, setInvoiceArray] = useState([]);
  const [metaobj, setMetaobj] = useState({});

  const [projectId] = useState(props.invoiceStat.projectId);
  const documents_blob_ids = [];
  const [fileArray, setFileArray] = useState([]);
  const config = JSON.parse(Config);
  let temp = '';

  const handleClose = () => {
    setOpen(false);
    props.setInvoiceEditing(false);
  };

  const handleInvoiceNum = (e) => {
    setInvoiceNum(e.target.value);
  };
  let x = [];

  const Layout = ({
    input,
    previews,
    submitButton,
    dropzoneProps,
    files,
    extra: { maxFiles },
  }) => {
    return (
      <div>
        {previews}

        <div {...dropzoneProps}>{files.length < maxFiles && input}</div>

        {files.length > 0 && submitButton}
      </div>
    );
  };
  const getUploadParams = () => {
    let headers = {
      Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
      'Access-Control-Allow-Origin': '*',
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    };
    return {
      url: process.env.REACT_APP_UPLOAD_DOWNLOAD + config['api'] + '/upload',
      headers,
    };
  };

  const handleChangeStatus = ({ meta, file, xhr }, status) => {
    var arr_blob_ids = [];

    if (status === 'done') {
      var json = JSON.parse(xhr.response);

      if (invoiceNum !== '') {
        metaobj[meta.name] = invoiceNum;
        setMetaobj(metaobj);
        setInvoiceArray([...invoiceArray, invoiceNum]);
      }
      if (json.key) {
        setFileArray([...fileArray, json.key]);
      }
      setInvoiceNum('');
    } else if (status === 'removed') {
      var json = JSON.parse(xhr.response);

      if (json.key) {
        arr_blob_ids = fileArray.filter((v) => v != json.key);
        setFileArray(arr_blob_ids);
      }
    }
  };

  const handleSubmit = (files, allFiles) => {
    //alert(JSON.stringify(fileArray));
    let some = files.map((f) => f.meta.name);

    if (!invoiceArray.length) {
      return false;
    } else {
      props.handleInvoice(invoiceArray, fileArray, props.invoiceStat);
      setOpen(false);
      setInvoiceArray([]);
    }

    allFiles.forEach((f) => f.remove());

    //console.log(some);
  };

  const Preview = ({ meta }) => {
    const { name, percent, status } = meta;
    //alert(JSON.stringify(metaobj));
    //const an = invoiceArray.map((ins, index) => ins);
    return (
      <p
        style={{
          alignSelf: 'flex-start',
          margin: '10px 3%',
          fontFamily: 'Roboto condensed',
          color: 'black',
          display: 'Block',
        }}
      >
        {metaobj[name]}&nbsp; &#8596; {name} &#8596; &nbsp;{' '}
        {Math.round(percent)}
        %, <span style={{ textTransform: 'capitalize' }}>{status}</span>
      </p>
    );
  };
  return (
    <ThemeProvider theme={theme}>
    <div>
    <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          style={{}}
        >
          <CustomDialogTitle onClose={handleClose}>
          <p style={{ fontSize: '1.5em' }}>Upload Invoice</p>
          </CustomDialogTitle>
          <CustomDialogContent dividers>
          <form
            enctype='multipart/form-data'
            className='form-horizontal '
            style={{ backgroundColor: '#eaf7fdcc' }}
            onSubmit={(event) => {
              event.preventDefault();
              //alert(fileArray);
              // props.handleInvoice(invoiceNum, fileArray, props.invoiceStat);
              setOpen(false);
              setInvoiceNum([]);
            }}
          >
            <div className='form-group'>
              <div className='col-md-12'>
                <TextField
                  type='text'
                  name='cityLeader'
                  id='standard-basic'
                  value={invoiceNum}
                  InputProps={{ inputProps: { min: 0 } }}
                  label='Enter in voice number:'
                  onChange={handleInvoiceNum}
                  style={{ border: 'none', width: '300px' }}
                  required
                  variant='standard'
                />
              </div>

              <br />
            </div>
            <div className='form-group'>
              <div className='col-md-12'>
                <Dropzone
                  onChangeStatus={handleChangeStatus}
                  getUploadParams={getUploadParams}
                  LayoutComponent={Layout}
                  multiple={false}
                  maxFiles={3}
                  PreviewComponent={Preview}
                  onSubmit={handleSubmit}
                  accept='image/*, .pdf'
                  styles={{
                    dropzone: { border: 'none', overflow: 'none !important' },
                  }}
                  inputContent='Click here to upload'
                  className='btn btn-secondary deca-btn-yellow a-update-email-alert'
                  disabled={!invoiceNum}
                />
              </div>
            </div>

            <div className='form-group'>
              <div className='col-sm-offset-2 col-sm-10'></div>
            </div>
          </form>
        </CustomDialogContent>
      </Dialog>
    </div>
    </ThemeProvider>
  );
};
export default UploadProjectInvoice;
